import {Stack} from "@mui/material";
import Grid from "@mui/material/Grid";
import React, {useEffect, useState} from "react";
import {UserDto} from "../../../../common/apis/user/UserDto";
import Dialog from "../../../../components/dialogs/Dialog";
import DialogContent from "../../../../components/dialogs/DialogContent";
import DialogTitle from "../../../../components/dialogs/DialogTitle";
import {_transl} from "../../../../store/localization/TranslMessasge";
import UserBasicInfoPanel from "./UserBasicInfoPanel";
import UserGroupMembershipPanel from "./groups/UserGroupMembershipPanel";
import UserPermissionPanel from "./permission/UserPermissionPanel";
import {UsersTranslationKey} from "./UsersTranslationKey";
import {UserValidator} from "./UserValidation";

interface UserDetailDialogProps {
    opened: boolean,
    onClose: (updated: boolean) => void,
    user: UserDto,
}

export default function UserDetailDialog(props: UserDetailDialogProps) {
    const {opened, onClose, user} = props;

    const [updated, setUpdated] = useState<boolean>(false);

    useEffect(() => {
        if (!opened) {
            setUpdated(false);
        }
    }, [opened]);

    function onUpdate() {
        setUpdated(true);
    }

    return (
        <Dialog open={opened}
                onClose={() => onClose(updated)}
                maxWidth={"lg"}>
            <DialogTitle id="user-detail-dialog-title"
                         title={_transl(UsersTranslationKey.USER)}
                         onDialogClosed={onClose}/>
            <DialogContent>
                <Grid container columnSpacing={3}>
                    <Grid item xs={12} md={6}>
                        <UserBasicInfoPanel
                                login={user.login}
                                onUpdate={() => onUpdate()}
                                userValidator={new UserValidator()}/>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Stack gap={3}>
                            <UserGroupMembershipPanel login={user.login}/>
                            <UserPermissionPanel user={user}/>
                        </Stack>

                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
